<div class="fixed inset-0 z-[70] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
  <div
    class="relative w-full max-w-4xl max-h-[90vh] bg-white/95 dark:bg-slate-900/95 border border-slate-100/50 rounded-[2rem] shadow-2xl flex flex-col animate-fade-in-up overflow-hidden">

    <!-- Modal Header -->
    <div
      class="flex items-center justify-between px-8 py-5 border-b border-slate-100/50 bg-white/50 backdrop-blur-md">
      <div>
        <h3 class="text-xl font-extrabold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500 text-2xl">request_quote</span>
          ขอใบกำกับภาษีเต็มรูป
        </h3>
        <p class="text-xs font-semibold text-slate-400 mt-1">
          กรอกข้อมูลลูกค้าทั้งหมดด้วยตนเอง — จากใบเสร็จ {{ record.receiptId || '-' }}
        </p>
      </div>
      <button (click)="onClose()" [disabled]="isSubmitting"
        class="w-10 h-10 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-500 transition-colors flex items-center justify-center shadow-sm hover:scale-105 active:scale-95 disabled:opacity-50">
        <span class="material-icons">close</span>
      </button>
    </div>

    <!-- Modal Body -->
    <div class="flex-1 p-8 overflow-y-auto custom-scrollbar" *ngIf="formData">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">

        <!-- Source receipt (readonly) -->
        <div class="flex flex-col gap-1.5">
          <label class="text-xs font-bold text-slate-500">เลขที่ใบเสร็จเดิม</label>
          <input type="text" [value]="record.receiptId" readonly
            class="w-full px-4 py-2.5 bg-slate-100 border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-500 outline-none cursor-not-allowed" />
        </div>

        <div class="flex flex-col gap-1.5">
          <label class="text-xs font-bold text-slate-500">ลานจอดรถ</label>
          <input type="text" [value]="record.siteName" readonly
            class="w-full px-4 py-2.5 bg-slate-100 border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-500 outline-none cursor-not-allowed" />
        </div>

        <!-- Customer Name -->
        <div class="flex flex-col gap-1.5 md:col-span-2">
          <label class="text-xs font-bold text-slate-500">ชื่อลูกค้า / บริษัท <span class="text-red-500">*</span></label>
          <input type="text" [(ngModel)]="formData.customerName"
            class="w-full px-4 py-2.5 bg-white border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-700 outline-none focus:ring-2 focus:ring-amber-400/50 transition-all shadow-sm" />
        </div>

        <!-- Tax ID -->
        <div class="flex flex-col gap-1.5">
          <label class="text-xs font-bold text-slate-500">เลขประจำตัวผู้เสียภาษี <span class="text-red-500">*</span></label>
          <input type="text" [(ngModel)]="formData.taxId"
            class="w-full px-4 py-2.5 bg-white border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-700 outline-none focus:ring-2 focus:ring-amber-400/50 transition-all shadow-sm" />
        </div>

        <!-- Branch / HQ -->
        <div class="flex flex-col gap-1.5">
          <label class="text-xs font-bold text-slate-500">สาขา / สำนักงานใหญ่</label>
          <div class="flex items-center gap-4 min-h-[42px] flex-wrap">
            <label class="flex items-center gap-2 cursor-pointer group">
              <input type="checkbox" [(ngModel)]="formData.headquarters"
                class="w-4 h-4 text-amber-500 border-slate-300 rounded focus:ring-amber-400" />
              <span class="text-sm font-semibold text-slate-600 group-hover:text-slate-800">สำนักงานใหญ่</span>
            </label>
            <ng-container *ngIf="!formData.headquarters">
              <input type="text" [(ngModel)]="formData.branchNo" placeholder="รหัสสาขา"
                class="flex-1 min-w-[120px] px-4 py-2 bg-white border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-700 outline-none focus:ring-2 focus:ring-amber-400/50 transition-all shadow-sm" />
              <input type="text" [(ngModel)]="formData.branchName" placeholder="ชื่อสาขา"
                class="flex-1 min-w-[120px] px-4 py-2 bg-white border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-700 outline-none focus:ring-2 focus:ring-amber-400/50 transition-all shadow-sm" />
            </ng-container>
          </div>
        </div>

        <!-- Address -->
        <div class="flex flex-col gap-1.5 md:col-span-2">
          <label class="text-xs font-bold text-slate-500">ที่อยู่ <span class="text-red-500">*</span></label>
          <textarea [(ngModel)]="formData.address" rows="3"
            class="w-full px-4 py-3 bg-white border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-700 outline-none focus:ring-2 focus:ring-amber-400/50 transition-all shadow-sm resize-none"></textarea>
        </div>

        <!-- Postcode -->
        <div class="flex flex-col gap-1.5">
          <label class="text-xs font-bold text-slate-500">รหัสไปรษณีย์</label>
          <input type="text" [(ngModel)]="formData.postcode"
            class="w-full px-4 py-2.5 bg-white border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-700 outline-none focus:ring-2 focus:ring-amber-400/50 transition-all shadow-sm" />
        </div>

        <!-- Create bill date -->
        <div class="flex flex-col gap-1.5">
          <label class="text-xs font-bold text-slate-500">วันที่ออกบิล</label>
          <input type="date" [(ngModel)]="formData.createBill"
            class="w-full px-4 py-2.5 bg-white border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-700 outline-none focus:ring-2 focus:ring-amber-400/50 transition-all shadow-sm" />
        </div>

        <!-- Contact -->
        <div class="flex flex-col gap-1.5">
          <label class="text-xs font-bold text-slate-500">เบอร์โทรศัพท์</label>
          <input type="text" [(ngModel)]="formData.telephone"
            class="w-full px-4 py-2.5 bg-white border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-700 outline-none focus:ring-2 focus:ring-amber-400/50 transition-all shadow-sm" />
        </div>

        <div class="flex flex-col gap-1.5">
          <label class="text-xs font-bold text-slate-500">อีเมล</label>
          <input type="email" [(ngModel)]="formData.email"
            class="w-full px-4 py-2.5 bg-white border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-700 outline-none focus:ring-2 focus:ring-amber-400/50 transition-all shadow-sm" />
        </div>

        <!-- Reference -->
        <div class="flex flex-col gap-1.5">
          <label class="text-xs font-bold text-slate-500">อ้างอิง (Reference)</label>
          <input type="text" [(ngModel)]="formData.reference"
            class="w-full px-4 py-2.5 bg-white border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-700 outline-none focus:ring-2 focus:ring-amber-400/50 transition-all shadow-sm" />
        </div>

        <!-- Type -->
        <div class="flex flex-col gap-1.5">
          <label class="text-xs font-bold text-slate-500">ประเภท (Type)</label>
          <input type="text" [(ngModel)]="formData.type"
            class="w-full px-4 py-2.5 bg-white border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-700 outline-none focus:ring-2 focus:ring-amber-400/50 transition-all shadow-sm" />
        </div>

        <!-- Details -->
        <div class="flex flex-col gap-1.5 md:col-span-2">
          <label class="text-xs font-bold text-slate-500">รายละเอียดในใบกำกับภาษี <span class="text-red-500">*</span></label>
          <textarea [(ngModel)]="formData.details" rows="2"
            class="w-full px-4 py-3 bg-white border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-700 outline-none focus:ring-2 focus:ring-amber-400/50 transition-all shadow-sm resize-none"></textarea>
        </div>

        <!-- Card name -->
        <div class="flex flex-col gap-1.5">
          <label class="text-xs font-bold text-slate-500">ชื่อบัตร (Card Name)</label>
          <input type="text" [(ngModel)]="formData.cardName"
            class="w-full px-4 py-2.5 bg-white border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-700 outline-none focus:ring-2 focus:ring-amber-400/50 transition-all shadow-sm" />
        </div>

        <!-- Remark -->
        <div class="flex flex-col gap-1.5">
          <label class="text-xs font-bold text-slate-500">หมายเหตุ</label>
          <input type="text" [(ngModel)]="formData.remark"
            class="w-full px-4 py-2.5 bg-white border border-slate-200/80 rounded-xl text-sm font-semibold text-slate-700 outline-none focus:ring-2 focus:ring-amber-400/50 transition-all shadow-sm" />
        </div>

        <!-- Amounts (readonly) -->
        <div
          class="md:col-span-2 mt-2 p-5 bg-amber-50/50 border border-amber-100 rounded-2xl flex flex-col gap-4">
          <h4 class="text-sm font-bold text-amber-800 border-b border-amber-200 pb-2">
            ข้อมูลจำนวนเงิน <span class="text-xs font-semibold text-amber-600 ml-2">(*อ่านอย่างเดียว คัดลอกจากใบเสร็จเดิม)</span>
          </h4>
          <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div>
              <label class="text-[11px] font-bold text-amber-600/70 uppercase">มูลค่าสินค้า/บริการ (Fee)</label>
              <div class="text-lg font-black text-amber-900 mt-1">{{ record.fee | number:'1.2-2' }}</div>
            </div>
            <div>
              <label class="text-[11px] font-bold text-amber-600/70 uppercase">ภาษีมูลค่าเพิ่ม (VAT)</label>
              <div class="text-lg font-black text-amber-900 mt-1">{{ record.vat | number:'1.2-2' }}</div>
            </div>
            <div>
              <label class="text-[11px] font-bold text-amber-600/70 uppercase">จำนวนเงินรวมทั้งสิ้น (Total)</label>
              <div class="text-xl font-black text-amber-600 mt-1">{{ record.total | number:'1.2-2' }}</div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Modal Footer -->
    <div
      class="px-8 py-5 border-t border-slate-100/50 flex items-center justify-end gap-3 bg-slate-50/50 backdrop-blur-sm rounded-b-[2rem]">
      <button (click)="onClose()" [disabled]="isSubmitting"
        class="px-6 py-2.5 bg-white border border-slate-200 hover:bg-slate-50 text-sm font-bold text-slate-600 rounded-xl transition-colors shadow-sm disabled:opacity-50">
        ยกเลิก
      </button>
      <button (click)="onSubmitRequest()" [disabled]="isSubmitting"
        class="flex items-center gap-2 px-6 py-2.5 bg-amber-400 hover:bg-amber-500 text-sm font-bold text-slate-900 rounded-xl transition-all shadow-md hover:shadow-lg disabled:opacity-50">
        <span class="material-icons text-sm" *ngIf="!isSubmitting">send</span>
        <span class="material-icons text-sm animate-spin" *ngIf="isSubmitting">autorenew</span>
        บันทึกคำขอใบกำกับภาษี
      </button>
    </div>
  </div>
</div>

<app-pss-loading *ngIf="isSubmitting" text="กำลังบันทึกคำขอใบกำกับภาษี..." detail="โปรดรอสักครู่ . . ."></app-pss-loading>

<app-pss-confirm-modal *ngIf="isConfirmModalOpen"
  title="ยืนยันการขอใบกำกับภาษีเต็มรูป?"
  message="คุณกำลังขอใบกำกับภาษีจากใบเสร็จเลขที่"
  [highlight]="record.receiptId || ''"
  messageSuffix="กรุณาตรวจสอบรายละเอียดให้ครบก่อนยืนยันรายการ"
  confirmLabel="ยืนยันขอใบกำกับภาษี"
  cancelLabel="กลับไปแก้ไข"
  variant="warning"
  icon="request_quote"
  [showIrreversibleNote]="false"
  (confirm)="onConfirmSubmit()"
  (cancel)="closeConfirmModal()">
</app-pss-confirm-modal>
